<template>
  <v-text-field-simplemask
    :label="label"
    v-model="model"
    :rules="rules"
    @input="$emit('input', model)"
    v-bind:properties="{
      prefix: '',
      suffix: '',
      readonly: false,
      disabled: false,
      outlined: true,
      dense: $root.dense,
      clearable: false,
      placeholder: ''
    }"
    v-bind:options="{
      inputMask: '(##)(###) ###-####',
      outputMask: '############',
      empty: null,
      applyAfter: false,
      alphanumeric: false,
      lowerCase: false
    }"
  >
  </v-text-field-simplemask>
</template>

<script>
import { PHONE } from "../../assets/js/rules";
export default {
  props: {
    value: [String, Number],
    label: {
      type: String,
      default: "Phone"
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      model: ""
    };
  },
  computed: {
    rules() {
      return this.required ? PHONE : [];
    }
  },
  mounted() {
    this.model = this.value;
  }
};
</script>

<style></style>
